// Bitflag values, must match EP.Core.Database.Enums.RepresentativeAccessTypes in EP.Service/EP.Database.
// Not the same as AccessType (access-types.enum.ts), which holds the same 7 flags as string names for JWT-claim-based route guards.
export enum RepresentativeAccessTypes {
  MerchantAdmin = 1,
  LoyaltyProgramAdmin = 2,
  Billing = 4,
  RepresentativeAdmin = 8,
  OfferAdmin = 16,
  ConsumerAdmin = 32,
  TeamAdmin = 64,
}
